import React from "react";

class ApAnnotationCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.ref = React.createRef();
  }

  componentDidMount() {
    //this.props.onAnnotationCardCreated(this.ref);
  }

  ready() {
    this.props.onAnnotationCardCreated(this.ref);
  }

  render() {
    const classes =
      "ApAnnotationCard" +
      (this.props.active ? " ApAnnotationCard-Active" : "");
    return (
      <div
        className={classes}
        style={{ animationDelay: `${this.props.id * 0.1}s` }}
        ref={this.ref}
        onClick={() => this.props.onClick()}
        onAnimationEnd={() => this.ready()}
      >
        <p id="Name">Kunde</p>
        <p id="Text">{this.props.text}</p>
        <p id="Expand" className="Link">
          Anzeigen
        </p>
      </div>
    );
  }
}

//onAnnotationCardCreated

export default ApAnnotationCard;



// WEBPACK FOOTER //
// ./src/components/approval/ApAnnotationCard.js